"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const useTranslate = (steps, keywords) => __async(null, null, function* () {
  const translationsMissing = steps.reduce((acc, step) => {
    for (let ki = 0; ki < keywords.length; ki += 1) {
      const keyword = keywords[ki];
      if (step[keyword] && acc.indexOf(step[keyword]) < 0) {
        acc.push(step[keyword]);
      }
    }
    return acc;
  }, []);
  try {
    const res = yield fetch("/app_tours/translations", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ translations: translationsMissing })
    });
    if (res.ok) {
      const data = yield res.json();
      return steps.reduce((acc, step) => {
        const updatedStep = __spreadValues({}, step);
        for (let ki = 0; ki < keywords.length; ki += 1) {
          const keyword = keywords[ki];
          updatedStep[keyword] = data.translations[updatedStep[keyword]];
        }
        acc.push(updatedStep);
        return acc;
      }, []);
    }
  } catch (error) {
    return steps;
  }
});
export { useTranslate };
